"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgBookmark = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.933 16.309a2 2 0 0 1 2.134 0c1.186.748 3.466 2.114 4.933 3.057V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.366c1.466-.943 3.747-2.31 4.933-3.057ZM12 18c1.559.983 5.051 3.116 5.844 3.652 1.008.682 2.156.322 2.156-.73V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16.923c0 1.05 1.148 1.41 2.156.729C6.95 21.116 10.441 18.983 12 18Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgBookmark);
//# sourceMappingURL=SvgBookmark.js.map